export default {
  'registerAsset(address,string,string,string,uint256,uint256[],bytes4[])': 'Register new asset `$3` (`$2`) at `$1` (reserve min: `$5`)',
  'registerExchangeAdapter(address,address,bool,bytes4[])': 'Register new adapter `$2` for exchange `$1`',
  'registerVersion(address,bytes32)': 'Register new version `$1`',
  'setIncentive(uint256)': 'Set incentive to `$1`',
  'setPriceSource(address)': 'Set price source to `$1`',
  'setMlnToken(address)': 'Set Melon token to `$1`',
  'setNativeAsset(address)': 'Set native asset to `$1`',
  'setEngine(address)': 'Set engine to `$1`',
  'setMGM(address)': 'Set MGM to `$1`',
  'setEthfinexWrapperRegistry(address)': 'Set Ethfinex wrapper registry to `$1`',
  'removeAsset(address,uint256)': 'Remove asset `$1`',
  'removeExchangeAdapter(address,uint256)': 'Remove exchange adapter `$1`',
  'registerFees(address[])': 'Register fees `$1`',
  'deregisterFees(address[])': 'De-register fees `$1`',
  'setRegistry(address)': 'Set registry to `$1`',
  'setAmguPrice(uint256)': 'Set AMGU price to `$1`'
}
